import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DxButtonModule, DxFormModule } from "devextreme-angular";
import { CreateEntityComponent } from "./create-entity.component";
import { TranslocoModule } from "@jsverse/transloco";
import { ButtonModule } from "../button/button.module";

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    ButtonModule,
    DxFormModule,
    DxButtonModule
  ],
  declarations: [CreateEntityComponent],
  exports: [CreateEntityComponent]
})
export class CreateEntityModule {}
